import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { UserRoutesAPI } from '../constants/user-routes';

@Injectable({})
export class TempCredentialService {

  static isTempCredentials(id: string): Promise<boolean> {
    return HttpService.get(UserRoutesAPI.USER_IS_TEMP_CREDENTIALS, { id } )
      .then(response => {
        return response.body as boolean;
      });
  }

}
